<template>
  <div class="selection-header">
    <div class="selection-info">
      <div class="badge">{{ selectedCount }}</div>
      <span class="selected-text">{{ $t('selected') }}</span>
    </div>
    <div class="action-buttons">
      <div class="divider" />
      <template v-for="(action, index) in actions" :key="action.label">
        <div
          class="action-btn"
          :title="action.label"
          @click="handleActionClick(action)"
        >
          <IconWrapper v-if="action.icon" :name="action.icon" class="action-icon" />
          <span class="action-label">{{ $t(action.label) }}</span>
        </div>
        <div v-if="index < actions.length - 1" class="divider" />
      </template>
      <div class="divider" />
    </div>
    <div class="close-btn" title="Dismiss" @click="handleDismiss">
      <IconWrapper name="closeIcon" class="close-icon" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ActionButton } from '@/interfaces'
import IconWrapper from '@/components/common/icons/IconWrapper.vue'

defineProps<{
  actions: ActionButton[]
  selectedCount: number
}>()

const emits = defineEmits<{
  'clear-selection': []
  'action-completed': [action: ActionButton]
}>()

function handleDismiss() {
  emits('clear-selection')
}

async function handleActionClick(action: ActionButton) {
  try {
    await action.onClick()
    emits('action-completed', action)
  } catch (err: unknown) {
    console.error('Error executing action:', err)
  }
}
</script>

<style scoped lang="scss">
.selection-header {
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 0;
  border: 1px solid $inputBorder;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.selection-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
}

.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 3px;
  background-color: $primary-color;
  color: $white;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.selected-text {
  font-size: 14px;
  font-weight: 700;
  color: $primary-color;
}

.divider {
  width: 1px;
  height: 24px;
  background-color: $borderSeparatorColor;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 0;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  color: $secondaryTitleText;

  &:hover {
    background-color: $background;
  }
}

.action-icon {
  width: 22px;
  height: 22px;
}

.action-label {
  text-align: center;
}

.close-icon {
  
  cursor: pointer;
  width: 22px;
  height: 22px;
  padding: 0.5rem;

  &:hover {
    background-color: $background;
  }
}
</style>